import React from 'react';
import { Avatar } from '~/components';
import { EntityIcon, EntityInfo, EntityName, EntityDetail, EntityRow, Mono } from './shared';

export default function MemberDisplay({ member, size = '1.75rem', badge = null }) {
  if (!member?.name) return <Mono>{member?.id || '-'}</Mono>;

  const avatarSize = Math.round(parseFloat(size) * 16);

  return (
    <EntityRow>
      <EntityIcon $size={size}>
        <Avatar value={{ name: member.name, imageUrl: member.imageUrl }} size={avatarSize} isCircle hasBackground />
      </EntityIcon>
      <EntityInfo>
        <EntityName>
          {member.name}
          {badge}
        </EntityName>
        <EntityDetail>{member.email}</EntityDetail>
      </EntityInfo>
    </EntityRow>
  );
}
